const isImgCloudBasePath =
  window.location.pathname === '/img-cloud' || window.location.pathname.startsWith('/img-cloud/');

export const ROUTES = {
  HOME: isImgCloudBasePath ? '/index.html' : '/',
  WEB_HOSTING: '/web-hosting',
  WEB_HOSTING_AI_PREVIEW: '/web-hosting/ai-preview',
  GALLERIES: '/galleries',
  DIRECTORIES: '/directories',
  INTERNATIONAL: '/international',
  IMAGE_CATEGORIES: '/image-categories',
  MONITOR: '/monitor',
  ABOUT: '/about',
  AI_INFO: '/ai-info',
  FAQ: '/faq',
  DEMO: '/demo',
  IMAGE_PROCESSING: '/image-processing',
  IMAGE_WATERMARK: '/image-watermark',
  VIDEO_TO_GIF: '/video-to-gif',
  VIDEO_COMPRESSOR: '/video-compressor',
  AI_GENERATE: '/ai-generate',
  IMAGE_SEARCH: '/image-search',
  TRASH: '/trash',
  INVITE: '/invite',
  ENCRYPTED_LINKS: '/encrypted-links',
} as const;

// 路由名称映射到翻译 key
export const ROUTE_TRANSLATION_KEYS = {
  [ROUTES.HOME]: 'routes.home',
  [ROUTES.WEB_HOSTING]: 'routes.webHosting',
  [ROUTES.WEB_HOSTING_AI_PREVIEW]: 'routes.webHosting',
  [ROUTES.GALLERIES]: 'routes.galleries',
  [ROUTES.DIRECTORIES]: 'routes.directories',
  [ROUTES.INTERNATIONAL]: 'routes.international',
  [ROUTES.IMAGE_CATEGORIES]: 'routes.imageCategories',
  [ROUTES.MONITOR]: 'routes.monitor',
  [ROUTES.ABOUT]: 'routes.about',
  [ROUTES.AI_INFO]: 'routes.aiInfo',
  [ROUTES.FAQ]: 'routes.faq',
  [ROUTES.DEMO]: 'routes.demo',
  [ROUTES.IMAGE_PROCESSING]: 'routes.imageProcessing',
  [ROUTES.IMAGE_WATERMARK]: 'routes.imageWatermark',
  [ROUTES.VIDEO_TO_GIF]: 'routes.videoToGif',
  [ROUTES.VIDEO_COMPRESSOR]: 'routes.videoCompressor',
  [ROUTES.AI_GENERATE]: 'routes.aiGenerate',
  [ROUTES.IMAGE_SEARCH]: 'routes.imageSearch',
  [ROUTES.TRASH]: 'routes.trash',
  [ROUTES.INVITE]: 'routes.invite',
  [ROUTES.ENCRYPTED_LINKS]: 'routes.encryptedLinks',
} as const;

// 为了向后兼容，保留 ROUTE_NAMES（中文默认值）
export const ROUTE_NAMES = {
  [ROUTES.HOME]: '首页',
  [ROUTES.WEB_HOSTING]: '网页托管',
  [ROUTES.WEB_HOSTING_AI_PREVIEW]: '网页托管',
  [ROUTES.GALLERIES]: '我的图集',
  [ROUTES.DIRECTORIES]: '目录管理',
  [ROUTES.INTERNATIONAL]: '国际图床',
  [ROUTES.IMAGE_CATEGORIES]: '图片分类',
  [ROUTES.MONITOR]: '监控',
  [ROUTES.ABOUT]: '关于',
  [ROUTES.AI_INFO]: 'AI 信息',
  [ROUTES.FAQ]: '常见问题',
  [ROUTES.DEMO]: '演示',
  [ROUTES.IMAGE_PROCESSING]: '图片处理',
  [ROUTES.IMAGE_WATERMARK]: '图片水印',
  [ROUTES.VIDEO_TO_GIF]: '视频转 GIF',
  [ROUTES.VIDEO_COMPRESSOR]: '视频压缩',
  [ROUTES.AI_GENERATE]: 'AI 生图',
  [ROUTES.IMAGE_SEARCH]: '图搜',
  [ROUTES.TRASH]: '回收站',
  [ROUTES.INVITE]: '邀请好友',
  [ROUTES.ENCRYPTED_LINKS]: '加密链接',
} as const;
